export default {
  recommend: {},
  section: [],
  data:[],
  notice:[]
}



// WEBPACK FOOTER //
// ./src/logic/home/state.js